module.exports = __webpack_public_path__ + "assets/29c7580c74019a8d3df420feda782b9d.png";